export default {
  name: 'vehicles/details',
}
